import { ENV } from '@/shared/config'
import type { Transport } from './transport'

export const fetchTransport: Transport = async ({ method, url, headers, body, signal }) => {
  const init: RequestInit = { method, headers, signal }

  if (body !== undefined) {
    init.body = body
  }

  const response = await fetch(`${ENV.API_BASE_URL}${url}`, init)
  const text = await response.text()

  let json: unknown = null

  if (text) {
    try {
      json = JSON.parse(text)
    } catch {
      // Не JSON: HTML от nginx на 502 и подобное. Разбирается как HTTP-ошибка без кода.
    }
  }

  return { status: response.status, json, requestId: response.headers.get('X-Request-Id') }
}
